import { ReactComponent } from './info-xl.svg';
export const InfoIconXl = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=info-xl.js.map